import { Reveal } from "../Reveal";
import { TURMAS, TURMAS_INTRO } from "../../config/site";

export const Turmas = () => {
  return (
    <section id="turmas" data-testid="turmas-grid" className="relative py-24 md:py-32 bg-sand">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="font-body text-xs tracking-[0.3em] uppercase text-gold">Turmas</span>
          <h2 className="font-display text-ink uppercase tracking-tight leading-[0.95] text-4xl md:text-5xl lg:text-6xl mt-5">Nossas turmas</h2>
          <p className="font-body text-slate/80 text-base md:text-lg leading-relaxed mt-6 max-w-3xl">{TURMAS_INTRO}</p>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-14">
          {TURMAS.map((t, i) => (
            <Reveal key={t.title} delay={(i % 3) * 0.06}>
              <article data-testid={`turma-card-${i}`} className="group h-full rounded-2xl border border-line bg-paper p-7 md:p-8 transition-all duration-500 hover:border-gold/50 hover:shadow-[0_16px_40px_rgba(17,18,20,0.06)] hover:-translate-y-1">
                <div className="flex items-center gap-2 mb-4">
                  <span className="w-6 h-[2px] bg-gold" />
                  {t.tag && <span className="font-body text-[11px] tracking-[0.18em] uppercase text-gold/80">{t.tag}</span>}
                </div>
                <h3 className="font-display text-ink uppercase tracking-[0.1em] text-xl md:text-2xl">{t.title}</h3>
                <p className="font-body text-slate/80 text-sm leading-relaxed mt-3">{t.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
